import { render, staticRenderFns } from "./BgImg.vue?vue&type=template&id=520c0e3e&scoped=true&"
import script from "./BgImg.vue?vue&type=script&lang=js&"
export * from "./BgImg.vue?vue&type=script&lang=js&"
import style0 from "./BgImg.vue?vue&type=style&index=0&id=520c0e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c0e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520c0e3e')) {
      api.createRecord('520c0e3e', component.options)
    } else {
      api.reload('520c0e3e', component.options)
    }
    module.hot.accept("./BgImg.vue?vue&type=template&id=520c0e3e&scoped=true&", function () {
      api.rerender('520c0e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BgImg.vue"
export default component.exports